import React, { Component } from 'react';
import PropTypes from 'prop-types';
import raf from 'raf';

const propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['auto']),
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['auto']),
    ]),
    engines: PropTypes.object,
    engine: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.object,
    ]),

    tick: PropTypes.bool,
    ready: PropTypes.bool,

    children: PropTypes.element,

    onTick: PropTypes.func,
    onReady: PropTypes.func,
    onTickReady: PropTypes.func,
    onSizeChange: PropTypes.func,
};

const defaultProps = {
    engine: 'pixi',
    engines: {},
    width: 'auto',
    height: 'auto',
    tick: true,
    ready: false,
    children: null,
    onTick: null,
    onReady: null,
    onTickReady: null,
    onSizeChange: null,
};

class Canvas extends Component {
    constructor(props) {
        super(props);

        this.engine = null;

        this.tick = this.tick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onEngineReady = this.onEngineReady.bind(this);
        this.onEngineTickReady = this.onEngineTickReady.bind(this);

        this.state = {
            ready: false,
            width: props.width !== 'auto' ? props.width : 0,
            height: props.height !== 'auto' ? props.height : 0,
            engineTick: null,
        };
    }

    componentDidMount() {
        if (this.props.width === 'auto' || this.props.height === 'auto') {
            this.updateSize();
        }

        window.addEventListener('resize', this.onResize);

        if (this.props.tick) {
            this.startTick();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            width: nextProps.width !== 'auto' ? nextProps.width : this.state.width,
            height: nextProps.height !== 'auto' ? nextProps.height : this.state.height,
        });
    }

    componentDidUpdate(prevProps) {
        const tickChanged = (
            prevProps.tick !== this.props.tick
        );
        const readyChanged = (
            prevProps.ready !== this.props.ready
        );

        if (readyChanged && this.props.ready && this.props.tick) {
            this.startTick();
        } else if (readyChanged && !this.props.ready && this.props.tick) {
            this.stopTick();
        }

        if (tickChanged && this.props.tick) {
            this.startTick();
        } else if (tickChanged && !this.props.tick) {
            this.stopTick();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);

        this.stopTick();
    }

    onResize() {
        if (this.props.width === 'auto' || this.props.height === 'auto') {
            this.updateSize();
        }
    }

    onEngineReady(...args) {
        this.setState({
            ready: true,
        });

        if (this.props.onReady) {
            this.props.onReady.call(this, ...args);
        }
    }

    onEngineTickReady(tick) {
        this.setState({
            engineTick: tick,
        });

        if (this.props.onTickReady) {
            this.props.onTickReady(tick);
        }
    }

    getEngineByName(name) {
        const normalizedName = name.replace(/[^a-z0-9]+/gi, '');
        const engineKey = Object.keys(this.props.engines).find(key => (
            normalizedName === key.replace(/[^a-z0-9]+/gi, '')
        ));
        return engineKey ? this.props.engines[engineKey] : null;
    }

    updateSize() {
        const el = this.engine.element;
        const parent = el.parentNode;
        const width = parent.offsetWidth;
        const height = parent.offsetHeight;

        const newWidth = this.props.width !== 'auto' ? this.props.width : width;
        const newHeight = this.props.height !== 'auto' ? this.props.height : height;

        const sizeChanged = (
            newWidth !== this.state.width ||
            newHeight !== this.state.height
        );
        const size = {
            width: newWidth,
            height: newHeight,
        };

        this.setState(size, () => {
            if (sizeChanged && this.props.onSizeChange) {
                this.props.onSizeChange(size);
            }
        });
    }

    startTick() {
        this.tickHandle = raf(this.tick);
    }

    stopTick() {
        if (this.tickHandle) {
            raf.cancel(this.tickHandle);
            this.tickHandle = null;
        }
    }

    tick() {
        this.tickHandle = raf(this.tick);

        if (this.props.onTick) {
            this.props.onTick();
        }

        if (this.state.engineTick) {
            this.state.engineTick();
        }
    }

    render() {
        const { engine, children } = this.props;
        const { width, height } = this.state;
        const Engine = typeof engine === 'string' ? this.getEngineByName(engine) : engine;

        return (
            <Engine
                {...this.props}
                ref={(ref) => { this.engine = ref; }}
                width={width}
                height={height}
                onReady={this.onEngineReady}
                onTickReady={this.onEngineTickReady}
            >
                { children }
            </Engine>
        );
    }
}

Canvas.propTypes = propTypes;
Canvas.defaultProps = defaultProps;

export default Canvas;



// WEBPACK FOOTER //
// ./vendor/react-draw/Canvas.jsx